import { createContext } from 'react'

const { Provider, Consumer } = createContext({ loading: false, viewer: null })

export { Provider, Consumer }



// WEBPACK FOOTER //
// ./src/components/CurrentUserContext.js